import { j as e } from "../../../node_modules/react/jsx-runtime.js";
import { clsx as A } from "../../../node_modules/clsx/dist/clsx.m.js";
import { memo as k, useState as j, useCallback as i } from "react";
import w from "../Badge/Badge.js";
import t from "./TabItem.module.scss.js";
import D from "../Flex/Flex.js";
import { Typography as L } from "../Typography/Typography.js";
import n from "../Icon/Icon.js";
const N = (c) => {
  const {
    label: m,
    leadingIcon: l,
    trailingIcon: d,
    showAlertIcon: u,
    iconOnly: r,
    isActiveTab: o,
    isDisabled: b,
    testId: I,
    keyVal: g,
    badgeValue: f,
    variantType: a = "horizontal",
    badge: s
  } = c, [x, h] = j(!1), [p, v] = j(!1), y = i(() => {
    h(!0);
  }, []), T = i(() => {
    h(!1), v(!1);
  }, []), z = i(() => {
    v(!0);
  }, []), C = A(t.button, {
    [t.disabled]: b,
    [t.staticIcon]: u,
    [t.verticalTab]: a === "vertical",
    [t.horizonatalTab]: a === "horizontal",
    [t.selectedTab]: o
  }), M = p ? "color/fg/brand/bold" : o || x ? "color/fg/brand/default" : "color/fg/lighter";
  return /* @__PURE__ */ e.jsxs(
    D,
    {
      ...a === "horizontal" && { flexCol: !0 },
      itemsCenter: !0,
      children: [
        o && a == "vertical" && /* @__PURE__ */ e.jsx("span", { className: t.verticalLine }),
        /* @__PURE__ */ e.jsx(
          "button",
          {
            className: C,
            "aria-selected": o,
            role: "tab",
            type: "button",
            disabled: b,
            "data-testid": I,
            onMouseEnter: y,
            onMouseLeave: T,
            onMouseDown: z,
            onClick: c.onClick,
            children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              !r && l && /* @__PURE__ */ e.jsx(n, { name: l }),
              !r && m ? /* @__PURE__ */ e.jsx(
                L,
                {
                  style: { transition: "ease-out", transitionDuration: "300ms" },
                  text: m,
                  variant: "interface/medium/sm",
                  textColor: M
                }
              ) : /* @__PURE__ */ e.jsx(n, { name: l || "" }),
              !r && d && /* @__PURE__ */ e.jsx(n, { name: d }),
              !r && (f || s) && /* @__PURE__ */ e.jsx(
                w,
                {
                  label: f || (s == null ? void 0 : s.label),
                  variant: "tinted",
                  color: o || p || x ? "primary" : "gray",
                  size: "small",
                  ...s
                }
              ),
              u && /* @__PURE__ */ e.jsx(
                n,
                {
                  name: "alert-circle-filled",
                  color: "red",
                  className: t.showAlertIcon
                }
              )
            ] })
          },
          g
        ),
        o && a == "horizontal" && /* @__PURE__ */ e.jsx("span", { className: t.horizontalLine })
      ]
    }
  );
}, $ = k(N);
export {
  N as TabItem,
  $ as default
};
//# sourceMappingURL=TabItem.js.map
